<template>
  <div
    class="d-flex align-items-stretch"
    :style="{
      flex: (flatOrders.length === 0) ? 1: 0
    }"
  >
    <template v-if="loading">
      <div class="w-100">
        <base-skeleton
          no-background
        >
          <div class="orders__grid">
            <div
              v-for="s in 12"
              :key="s"
              class="skeleton__item mr-0 mt-0"
              :style="{
                'opacity': 0 + (1 /s),
                width: !responsive.lg? '109px': '109px',
                height: !responsive.lg? '86px': '109px'
              }"
            />
          </div>
        </base-skeleton>
      </div>
    </template>

    <template v-else>
      <template v-if="flatOrders.length === 0">
        <empty title="No order history data yet" />
      </template>
      <div
        v-else
        class="orders__grid"
      >
        <div
          v-for="(order, index) in flatOrders"
          :key="`element_${index}`"
          class="grid-item d-flex justify-content-center align-items-center"
        >
          <div
            v-if="order.isOrderTitle"
            class="gray"
          >
            <base-text size="s">
              {{ order.timestamp | nicedate('small') }}
            </base-text>
            <base-text size="s">
              Order {{ order.id ? order.id : '-- No id --' | truncate(10) }}
            </base-text>
            <base-text size="s">
              {{ order.amount | formatPrice }}
            </base-text>
          </div>
          <div v-else>
            <product
              :key="`test-order_${index}`"
              :thumbnail="order.product.thumb"
              :thumbnail-size="responsive.lg? 'medium': 'small'"
              :name="getProductName(order)"
              :price="order.product.formatted_price"
              :size="order.product.size_info"
              :url="order.product.site_url"
              :last-update="order.last_update? order.last_update:order.timestamp"
            />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import utilsMixin from '@/_utilities/utilsMixin';
import responsive from '@/components/mixins/responsive';

export default {
  name: 'Orders',
  mixins: [utilsMixin, responsive],
  props: {
    orders: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    flatOrders() {
      return this.orders
        .map((order) => [
          {
            isOrderTitle: true,
            id: order.external_id,
            timestamp: order.timestamp,
            amount: this.getAmount(order.sales),
          },
          ...order.sales,
        ])
        .flat();
    },
  },
  methods: {
    getAmount(sales) {
      return sales.reduce((a, b) => a + b.amount, 0);
    },
  },
};
</script>
<style lang="scss" scoped>
.orders__grid{
  display: grid;
  column-gap: 10px;
  grid-template-columns: repeat(auto-fit, 110px);
  row-gap: 10px;
  width: 100%;
  @media screen and (min-width: map-get($breakpoints,'lg')){
    grid-template-columns: repeat(auto-fit, 120px);;
  }
}
.product-img {
  height: 100px !important;
}

.grid-item {
  // width: 109px;
  width: 100%;
  min-width: 100px;
}

.gray {
  color: #aaaaaa;
}

/* .max-height {
  max-height: 500px;
  overflow-y: scroll;
} */

.tooltip-divider {
  border: 0.5px solid #ffffff33;
  margin: 0.3rem 0;
  padding: 0;
}
.tight {
  line-height: 0.95rem;
}
</style>
